import closeAllUILessAddinsForItem from './closeAllUILessAddinsForItem';

export default function onComposeClose(hostItemIndex: string) {
    closeAllUILessAddinsForItem(hostItemIndex);
}
